export const table = [
  { title: 'ID', id: 1 },
  { title: 'Название', id: 2 },
];
